import { render } from "./LikeInfo.vue?vue&type=template&id=3f43b592"
import script from "./LikeInfo.vue?vue&type=script&lang=js"
export * from "./LikeInfo.vue?vue&type=script&lang=js"

import "./LikeInfo.vue?vue&type=style&index=0&id=3f43b592&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__